export default __webpack_public_path__ + "static/media/volume-duo.23461ebb.svg";